<div class="bg_image">
    <div class="row">
        <div class="col-md-6 mt-5">
            <img src="assets\img\background\NBR_logo.jpg" class="nbr_logo">
        </div>
        <!-- <div class="col-md-6 mt-4">
            <img src="assets\img\logo\mujib_borsho.svg" class="mujib100_logo">
        </div> -->
    </div>
    <div class="container">
        <div class="main_section">
            <div class="row">
                <!-- <div class="col-6" style="padding-left: 0;">
                    <div *ngFor="let language of languageList" class="float-left">
                        <button (click)="languageClick(language.code)"
                            [class.activeLan]="getSelectedLanguagesCode()===language.code"
                            class="btn btn-sm btn-outline-dark mr-2">{{language.label}}</button>
                    </div>

                </div> -->
                <div class="col-12 text-center p-0">
                    <!-- <label class="label custom mt-2"><b>{{content('eReturn Usermanual')}}</b></label> -->
                    <label class="label custom my-4"><b>eReturn User Manual</b></label>
                </div>
            </div>
        </div>

        <!-- <div *ngIf="isLoading" class="spinner">

        </div> -->
        <div>
        <pdf-viewer *ngIf="EN" [src]="pdfSrcEN" [render-text]="true" style="width:100%; height:700px"
            (after-load-complete)="afterLoadComplete($event)"></pdf-viewer>
        <!-- <pdf-viewer *ngIf="BN" [src]="pdfSrcBN" [render-text]="true" style="width:100%; height:700px"
            (after-load-complete)="afterLoadComplete($event)"></pdf-viewer> -->
    </div>

    <!-- <div>
            <pdf-viewer *ngIf="EN" [src]="pdfSrcEN" [render-text]="true" style="width:100%; height:700px" ></pdf-viewer>
            <pdf-viewer *ngIf="BN" [src]="pdfSrcBN" [render-text]="true" style="width:100%; height:700px" ></pdf-viewer>
        </div> -->

    <!-- <div>
            <object *ngIf="EN" data="assets\user-manual\UserManualEN.pdf" type="application/pdf" width="100%" height="700px"> </object>
            <object *ngIf="BN" data="assets\user-manual\UserManualBN.pdf" type="application/pdf" width="100%" height="700px"> </object>
        </div>  -->


    <!-- <div *ngIf= getSelectedLanguagesCode() > -->
    <!-- <iframe src="assets\user-manual\UserManualEN.pdf" style="width:100%;height:700px;"></iframe> -->
    <!-- <iframe *ngIf=!{{ getSelectedLanguagesCode() }} src="assets\user-manual\UserManualEN.pdf" style="width:100%;height:700px;"></iframe> -->
    <!-- <object data="assets\user-manual\UserManualEN.pdf" type="application/pdf" width="300" height="200"> -->
    <!-- alt : <a href="assets\user-manual\UserManualEN.pdf">Usermanual.pdf</a> -->
    <!-- </object> -->
    <!-- </div> -->

</div>
<div class="row mt-3">
    <div class="col-12">
        <button type="button" class="btn btn-sm backBtn mb-3" (click)="onBacktoMainPage()">
            <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left"
                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
            </svg>&nbsp;
            Back &nbsp;&nbsp;&nbsp;</button>
    </div>
</div>
</div>
<ngx-ui-loader></ngx-ui-loader>
